module.exports = __webpack_public_path__ + "img/sticker_1.cd3d2013.svg";